import { LotteryFAQ } from '../../../lotteries/LotteryFAQ/LotteryFAQ';
import type { LotteryName } from '../../../lottery-purchases/types';
import type { ResultsConfig } from '../../types';
import { ResultsDrawHistoryPage } from './ResultsDrawHistoryPage';

type ResultsDrawHistoryPageComponentProps = {
  lotteryName: LotteryName;
  config?: ResultsConfig;
  backFallbackUrl?: string;
  headerTitle?: string;
};

function ResultsDrawHistoryPageComponent({ lotteryName, config, backFallbackUrl, headerTitle }: ResultsDrawHistoryPageComponentProps) {
  return (
    <ResultsDrawHistoryPage lotteryName={lotteryName} className="mb-10" config={config} backFallbackUrl={backFallbackUrl} headerTitle={headerTitle}>
      <LotteryFAQ lotteryName={lotteryName} faqPage="results" />
    </ResultsDrawHistoryPage>
  );
}

export { ResultsDrawHistoryPageComponent, type ResultsDrawHistoryPageComponentProps };
